import { ChangeDetectorRef, Component } from "@angular/core";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";

import { I18nService } from "@bitwarden/common/platform/abstractions/i18n.service";
import {
  AnonLayoutWrapperComponent,
  AnonLayoutWrapperDataService,
  TypographyModule,
} from "@bitwarden/components";

// FIXME(https://bitwarden.atlassian.net/browse/CL-764): Migrate to OnPush
// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  templateUrl: "./brackets-vault-auth-layout-wrapper.component.html",
  styles: [
    `
      .brackets-auth-layout__secondary:empty {
        display: none;
      }

      .brackets-auth-layout__title {
        font-size: 2rem;
        font-weight: 700;
        line-height: 1.2;
      }
    `,
  ],
  imports: [RouterModule, TypographyModule],
})
export class BracketsVaultAuthLayoutWrapperComponent extends AnonLayoutWrapperComponent {
  constructor(
    router: Router,
    route: ActivatedRoute,
    i18nService: I18nService,
    anonLayoutWrapperDataService: AnonLayoutWrapperDataService,
    changeDetectorRef: ChangeDetectorRef,
  ) {
    super(router, route, i18nService, anonLayoutWrapperDataService, changeDetectorRef);
  }
}
